import { ModalBase, STATUSPAGE } from '@repo/ui';
import { FormikValues } from 'formik';
import { LoadingStates } from 'presentation/app/modules/Entities/hooks/useEntities';
import { Row, Col, Label, Form, Input } from 'reactstrap';

interface IProps {
  isOpen: boolean;
  loadingFieldAssessments: LoadingStates;
  validationFieldAssessments: FormikValues;
  toggleModal: () => void;
}

export const ModalEditFieldAssessments = ({
  toggleModal,
  isOpen,
  loadingFieldAssessments,
  validationFieldAssessments,
}: IProps) => {
  return (
    <ModalBase.Wrapper
      isOpen={isOpen}
      toggle={toggleModal}
      size="lg"
      loading={
        loadingFieldAssessments.getByIdFieldAssessments === STATUSPAGE.LOADING
      }
    >
      <Form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          validationFieldAssessments.handleSubmit();
          return false;
        }}
      >
        <ModalBase.Header toggle={toggleModal} withBorderBottom>
          Editar Questão da Avaliação
        </ModalBase.Header>
        <ModalBase.Body>
          <Row>
            <Col md={12}>
              <Label htmlFor="nameValueModal" className="form-label">
                Questão da Avaliação
              </Label>
              <Input
                type="text"
                autoFocus={true}
                id="nameValueModal"
                name="nameValueModal"
                className="form-control"
                placeholder="Digite o nome da questão"
                onBlur={validationFieldAssessments.handleBlur}
                onChange={validationFieldAssessments.handleChange}
                value={validationFieldAssessments.values.nameValueModal}
              />
            </Col>
          </Row>
        </ModalBase.Body>
        <ModalBase.Footer>
          <ModalBase.Actions
            actionBtnType="submit"
            goBack={toggleModal}
            loading={
              loadingFieldAssessments.updateFieldAssessments ===
              STATUSPAGE.LOADING
            }
          />
        </ModalBase.Footer>
      </Form>
    </ModalBase.Wrapper>
  );
};
